<div class="app-container">
  <loading-spinner [isLoading]="loading" [classesString]="'top-50'"></loading-spinner>
  @if (company) {
    <form [formGroup]="companySettingsForm" (ngSubmit)="updateCompany()">
      <page-header
        [title]="'company.settings'"
        [appendNoTranslationTitlePart]="company ? company.name : ''"
        [icon]="'far-cog'"
      >
        <ng-container class="header-button">
          <btn
            [label]="'save'"
            [title]="'save' | translate"
            [classes]="['btn-first', 'float-right']"
            [icon]="'far-check'"
            [btnType]="'submit'"
            [isLoading]="loading"
            [spinnerClassesString]="'spinner-white'"
            [btnDisabled]="loading"
            [dataCyAttribute]="'edit-company'"
          ></btn>
          @if (company?.id) {
            <modal-loggable-history [objectClass]="'Company'" [objectId]="company.id"></modal-loggable-history>
          }
        </ng-container>
      </page-header>
      <section class="content">
        <div class="card">
          <div class="row">
            <div class="col-sm-6">
              <form-row-input
                [label]="'name'"
                [icon]="null"
                [formGroup]="companySettingsForm"
                formControlName="name"
                [dataCyAttribute]="'name'"
              ></form-row-input>
              <form-row-input
                [label]="'email'"
                [icon]="null"
                [formGroup]="companySettingsForm"
                formControlName="email"
                [required]="
                  companySettingsForm.get('email').errors !== null && companySettingsForm.get('email').errors.required
                "
                [requiredCssClass]="submitted && formControls.email.errors"
                [dataCyAttribute]="'email'"
              ></form-row-input>
              <form-row-input
                [label]="'phone'"
                [icon]="null"
                [formGroup]="companySettingsForm"
                formControlName="phone"
                [dataCyAttribute]="'phone'"
              ></form-row-input>
              <form-row-input
                [label]="'company.ic'"
                [icon]="null"
                [formGroup]="companySettingsForm"
                formControlName="ic"
                [dataCyAttribute]="'ic'"
              ></form-row-input>
              <form-row-input
                [label]="'company.dic'"
                [icon]="null"
                [formGroup]="companySettingsForm"
                formControlName="dic"
                [dataCyAttribute]="'dic'"
              ></form-row-input>
              <form-row-input
                [label]="'street'"
                [icon]="null"
                [formGroup]="companySettingsForm"
                formControlName="street"
                [dataCyAttribute]="'street'"
              ></form-row-input>
              <form-row-input
                [label]="'city'"
                [icon]="null"
                [formGroup]="companySettingsForm"
                formControlName="city"
                [dataCyAttribute]="'city'"
              ></form-row-input>
              <form-row-input
                [label]="'zip'"
                [icon]="null"
                [formGroup]="companySettingsForm"
                formControlName="zip"
                [dataCyAttribute]="'zip'"
              ></form-row-input>
              <form-row-select
                [label]="'country'"
                [options]="countries"
                [icon]="null"
                [formGroup]="companySettingsForm"
                formControlName="country"
                [optionKey]="'code'"
                [required]="
                  companySettingsForm.get('country').errors !== null &&
                  companySettingsForm.get('country').errors.required
                "
                [requiredCssClass]="submitted && formControls.country.errors"
                [dataCyAttribute]="'company-country-select'"
              >
              </form-row-select>
              <form-row-input
                [label]="'company.registrationNote'"
                [icon]="null"
                [formGroup]="companySettingsForm"
                formControlName="registrationNote"
                [dataCyAttribute]="'registrationNote'"
              ></form-row-input>
              <form-row-input
                [label]="'defaultVoucherValidity'"
                [icon]="null"
                [inputType]="'number'"
                [formGroup]="companySettingsForm"
                formControlName="defaultVoucherValidity"
                [dataCyAttribute]="'defaultVoucherValidity'"
              ></form-row-input>
              <form-row-input
                [label]="'company.nextEan'"
                [icon]="null"
                [formGroup]="companySettingsForm"
                formControlName="nextEan"
                [dataCyAttribute]="'company.nextEan'"
              ></form-row-input>
              <form-row-input
                [label]="'company.nextCode'"
                [icon]="null"
                [formGroup]="companySettingsForm"
                formControlName="nextCode"
                [dataCyAttribute]="'company.nextCode'"
              ></form-row-input>
              <!--            todo add to test-->
              <!--            [photoGalleryCaption]="-->
            </div>

            <div class="col-sm-6">
              <div class="row">
                <div class="col-12">
                  <div class="card-title">
                    {{ 'company.logo' | translate }}
                  </div>
                </div>
              </div>

              @if (companySettingsForm.value.logo?.id) {
                <div class="img-card w-fit-content" [photoGalleryGroup]="{ index: 1 }">
                  <div class="img-container">
                    <div>
                      @if (
                        !!companySettingsForm.value.logo?.url?.length &&
                        !!companySettingsForm.value.logo?.thumbnails?.length
                      ) {
                        <img
                          class="images-item-image"
                          [src]="getThumbUrl(companySettingsForm.value.logo)"
                          [alt]="companySettingsForm.value.logo?.text"
                        />
                      }
                      @if (
                        !companySettingsForm.value.logo?.url?.length ||
                        !companySettingsForm.value.logo?.thumbnails?.length
                      ) {
                        <img
                          class="images-item-image"
                          [src]="'assets/img/no-image.png'"
                          [alt]="companySettingsForm.value.logo?.text"
                        />
                      }
                    </div>
                    <div class="images-item-name mt-3">
                      <a
                        href="{{ companySettingsForm.value.logo.url }}"
                        target="_blank"
                        title="{{ 'open' | translate }}"
                        >{{ companySettingsForm.value.logo.text }}</a
                      >
                    </div>
                  </div>
                  <div class="d-flex justify-content-space-between">
                    <button
                      ngx-dropzone
                      class="btn-edit btn-sm h-30px"
                      [type]="'button'"
                      [accept]="acceptedFileTypes"
                      (change)="onSelect($event)"
                      [title]="'edit'"
                    >
                      <i class="far fa-pencil"></i>
                    </button>
                    <btn
                      [title]="'delete' | translate"
                      [icon]="'far-trash-alt'"
                      [classes]="['btn-trash', 'btn-sm', 'float-right']"
                      (click)="removeLogo(companySettingsForm.value.logo)"
                      [dataCyAttribute]="'product-image-delete'"
                    ></btn>
                  </div>
                </div>
              }
              @if (!companySettingsForm.value.logo) {
                <div
                  class="new-img-dropzone ms-2 mt-2 w-fit-content"
                  ngx-dropzone
                  (change)="onSelect($event)"
                  [accept]="acceptedFileTypes"
                >
                  <div class="d-flex flex-column m-3">
                    <ngx-dropzone-label><i class="far fa-file-import"></i></ngx-dropzone-label>
                    <ngx-dropzone-label>
                      {{ 'upload.image' | translate }}
                    </ngx-dropzone-label>
                  </div>
                  <loading-spinner [isLoading]="loading"></loading-spinner>
                </div>
              }
            </div>
          </div>
        </div>
      </section>
    </form>
  }
</div>
